<!--
 * @Author: Ximen
 * @Date: 2021-03-23 19:40:08
 * @LastEditors: Ximen
 * @LastEditTime: 2021-04-08 19:18:27
-->
<template>
  <a-modal v-model:visible="visible"
  :footer="null" width="420px" @cancel="close()">
    <p class="title">升级套餐订购</p>
    <p>订购高级版本更多细节，将由专属客户经理与您进行深入沟通，请提供您的联系方式，方便我们与您取得联系</p>
    <a-form :model="formState" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-item label="订购套餐">
        <span style="margin-left:10px">{{payInfo.name}}</span>
      </a-form-item>
      <a-form-item label="您的称呼">
        <div style="margin-left:10px">
          <a-input v-model:value="formState.name" />
        </div>
      </a-form-item>
      <a-form-item label="您的性别">
        <div style="margin-left:10px">
          <a-radio-group v-model:value="formState.value">
            <a-radio :style="radioStyle" :value="1">先生</a-radio>
            <a-radio :style="radioStyle" :value="2">女士</a-radio>
          </a-radio-group>
        </div>
      </a-form-item>
      <a-form-item label="联系电话">
        <div style="margin-left:10px">
          <a-input v-model:value="formState.mobile" />
        </div>
      </a-form-item>
    </a-form>
    <a-button type="primary" class="subBtn" @click="apply()">立即申请</a-button>
  </a-modal>
</template>

<script lang='ts'>
import { defineComponent, h } from 'vue';
import { message as $message, Modal } from 'ant-design-vue';
import commonApi from '@/api/common';

export default defineComponent({
  name: 'UserInfoModal',
  data() {
    return {
      visible: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
      formState: {
        name: '',
        mobile: '',
        value: 1,
      },
    };
  },
  setup() {
    const error = (str: string) => {
      $message.error(str);
    };
    const success = (str: string) => {
      $message.success(str);
    };
    return {
      error,
      success,
    };
  },
  props: ['payInfo'],
  components: {
  },
  methods: {
    showModal() {
      this.visible = true;
    },
    apply() {
      interface Data{
        result: number;
        message: string;
      }
      if (!this.formState.name) {
        this.error('请输入您的称呼');
        return;
      }
      if (!this.formState.mobile) {
        this.error('请输入联系方式');
        return;
      }
      console.log(this.formState);
      const param = {
        name: this.formState.name + (this.formState.value === 1 ? '先生' : '女士'),
        companyName: this.payInfo.name,
        mobile: this.formState.mobile,
      };
      commonApi.addVersion(param).then(async ({ result, message }: Data) => {
        if (result === 1) {
          Modal.success({
            title: '提交成功',
            okText: '好的',
            content: h('div', {}, [
              h('p', '已收到您的套餐订购申请，专属客户经理预计在1个工作日与您联系，请确保联系电话畅通'),
            ]),
          });
          this.visible = false;
        } else {
          this.error(message);
        }
      });
    },
  },
});
</script>
<style lang="stylus" scoped>
  ::v-deep .ant-form-item
    margin-bottom 0
  .title
    font-size 24px
    color #073D7D
    text-align center
    margin-bottom 15px
  .subBtn
    width 100%
    height 50px
    margin-top 25px
    border-radius 5px
    background #3281DD
</style>
